<template>
    <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        <div class="kt-portlet kt-portlet--mobile">
            <div class="kt-portlet__head kt-portlet__head--lg no-border-radius">
                <div class="kt-portlet__head-label">
                    <Dropdown v-model="selectedOrg" :options="organizations" optionLabel="display_name" dataKey="id"
                            filter :placeholder="$t('AppWorkDataUpload.Selecione a organização')" style="width: 250px" />
                </div>
            </div>
            <div class="kt-portlet__body no-padding">
                <div v-if="!selectedOrg"  class="d-flex justify-content-center mt-5">
                    <div class="text-center flex-column kt-font-lg">
                        <div class="font-weight-bold kt-font-xl">
                            {{ $t('AppWorkDataUpload.Selecione uma organização!') }}
                        </div>
                    </div>
                </div>
                <div v-else class="d-flex justify-content-center align-items-center mt-4">
                    <div class="d-flex flex-column work-data-card p-4 col-3">
                        <div v-if="loading" class="d-flex flex-column align-items-center">
                            <ProgressSpinner/>
                        </div>
                        <div v-else>
                            <div class="d-flex flex-column kt-font-lg my-3" style="align-items: center;">
                                <div class="d-flex flex-column align-items-center">
                                    <div>
                                        <div>
                                            {{ $t('AppWorkDataUpload.Chassis') }}
                                        </div>
                                        <div class="px-1 mt-1">
                                            <InputText v-model="vin" class="input-width" maxlength="30" :placeholder="$t('AppWorkDataUpload.Digite o chassis')"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="align-items-center mt-4" style="width: 330px;">
                                    <div>
                                        <div>
                                            {{ $t('AppWorkDataUpload.Arquivo') }}
                                        </div>
                                        <div class="px-1 mt-1">
                                            <FileUpload mode="basic" accept=".zip" :maxFileSize="100000000" :chooseLabel="$t('AppWorkDataUpload.Adicionar')" @select="fileSelected"
                                                :customUpload="true" :placeholder="$t('AppWorkDataUpload.Selecione o arquivo zip')" 
                                                :buttonStyle="{'height': '35px', 'font-size': '14px', 'max-width': '101%'}"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="align-items-center mt-4" style="width: 330px;">
                                    <div>
                                        <div>
                                            {{ $t('AppWorkDataUpload.Tipo de arquivo') }}
                                        </div>
                                        <div class="px-1 mt-1">
                                            <SelectButton v-model="fileType" :options="typeOptions" />
                                        </div>
                                    </div>
                                </div>
                                <div class="align-items-center mt-4" style="width: 330px;">
                                    <div>
                                        <div>
                                            {{ $t('AppWorkDataUpload.Início do trabalho (opcional)') }}
                                        </div>
                                        <div class="px-1 mt-1">
                                            <Calendar v-model="workStart" class="input-width" dateFormat="dd/mm/yy"
                                                :showButtonBar="true" :manualInput="false" :maxDate="new Date()"
                                                :placeholder="$t('AppWorkDataUpload.Selecione a data de início')"/>
                                        </div>
                                        <div class="px-1 mt-2 work-start-hint">
                                            <i class="pi pi-info-circle mr-1"/>
                                            <span>{{ $t('AppWorkDataUpload.workStartHint') }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-end mt-4">
                                <Button :label="$t('AppWorkDataUpload.Enviar')" @click="sendWorkData"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import InputText from 'primevue/inputtext';
import Calendar from 'primevue/calendar';
import FileUpload from 'primevue/fileupload';
import SelectButton from 'primevue/selectbutton';
import ProgressSpinner from 'primevue/progressspinner';
import OrganizationsService from "@/services/OrganizationsService";
import WorkDataUploadService from "@/services/WorkDataUploadService";

export default {
    mounted() {
        this.organizationsService = new OrganizationsService();
        this.workDataUploadService = new WorkDataUploadService();
        this.getOrganizations();
    },
    data() {
        return {
            vin: null,
            file: null,
            workStart: null,
            loading: false,
            organizations: [],
            selectedOrg: null,
            fileType: 'SATLOC',
            organizationsService: null,
            workDataUploadService: null,
            typeOptions: ['SATLOC', 'AGNAVE']
        }
    },
    methods: {
        getOrganizations() {
            this.organizationsService.getAllV3()
                .then((response) => {
                    this.organizations = response.sort((a, b) => a.name.localeCompare(b.name));
                    this.selectSavedOrg();
                })
                .catch(() => {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppWorkDataUpload.Não foi possivel buscar as organizações'),
                        life: 5000
                    });
                })
        },
        selectSavedOrg() {
            this.storedChosenOptions = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE_FILTER_BAR_OPTIONS));

            if (!this.storedChosenOptions || !this.storedChosenOptions.clients || this.storedChosenOptions.clients.length === 0) {
                this.storedChosenOptions = {};
                return;
            }

            this.selectedOrg = this.organizations.filter(a => this.storedChosenOptions['clients'].some(b => a.id === b.id))[0];
        },
        saveChosenOptionsToLocalStorage() {
            this.storedChosenOptions['clients'] = [this.selectedOrg];
            this.storedChosenOptions['vehicles'] = [];
            localStorage.setItem(process.env.VUE_APP_LOCAL_STORAGE_FILTER_BAR_OPTIONS, JSON.stringify(this.storedChosenOptions));
        },
        sendWorkData() {
            if (!this.vin || this.vin.trim() === '' || !this.selectedOrg || !this.file) {
                this.$toast.add({
                    severity: 'warn',
                    summary: this.$t('AppWorkDataUpload.O vin e o arquivo são obrigatórios!'),
                    life: 5000
                });
                return;
            }

            this.loading = true;
            let formData = new FormData();
            formData.append("vin", this.vin);
            formData.append("file", this.file);
            formData.append("file_type", this.fileType);
            if (this.workStart) {
                formData.append("work_start", this.formatWorkStart(this.workStart));
            }
            this.workDataUploadService.sendWorkData(this.selectedOrg.id, formData)
                .then(() => {
                    this.$toast.add({
                        severity: 'success',
                        summary: this.$t('AppWorkDataUpload.Enviado com sucesso'),
                        life: 5000
                    });

                    this.file = null;
                    this.vin = null;
                    this.workStart = null;
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.getWorkDataErrorMessage(error),
                        life: 5000
                    });
                    
                    this.file = null;
                    this.vin = null;
                    this.workStart = null;
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        getWorkDataErrorMessage(error) {
            if (error.response && error.response.status && error.response.status === 400) {
                return this.$t('AppWorkDataUpload.O arquivo não é válido!');
            }
            return this.$t('AppWorkDataUpload.Erro ao processar arquivo');
        },
        fileSelected(event) {
            this.file = event.files[0];
        },
        formatWorkStart(date) {
            let pad = (value) => String(value).padStart(2, '0');
            return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
        }
    },
    watch: {
        selectedOrg: function (val) {
            if (val) {
                this.saveChosenOptionsToLocalStorage();
            }
        },
        vin: function (val) {
            this.vin = val.replace(/\s+/g, '');
        }
    },
    components: {
        Dropdown, FileUpload, InputText, Button, ProgressSpinner, SelectButton, Calendar
    }
}
</script>

<style scoped>
.work-data-card {
    background: white;
    border-radius: 1rem;
}

.input-width {
    width: 330px;
}

.work-start-hint {
    display: flex;
    align-items: flex-start;
    font-size: 12px;
    line-height: 1.35;
    color: #74788d;
}

.work-start-hint .pi {
    font-size: 12px;
    margin-top: 2px;
}

.card-divider {
    border-bottom: lightgrey 1px dashed;
    width: 70%;
}
</style>
